import { FormattedMessage } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, BrandM } from '@sorare/core/src/atoms/typography';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Tile } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/index.tsx';
import { DiamondBaseColor } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/utils.ts';
import nbaStadiumFire from '#src/components/series/SeriesBoard/NextTrckTile/assets/nbaStadiumFire.webp';
import stadiumFire from '#src/components/series/SeriesBoard/NextTrckTile/assets/stadiumFire.webp';

export const VIEW_TRANSITION_NAME = 'new-chapter-overlay';

const Overlay = styled(Vertical).attrs({ center: true })`
  position: fixed;
  inset: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
`;

const OverlayContent = styled(Vertical)`
  align-items: center;
  gap: var(--double-unit);
`;

const fireIconAnimation = keyframes`
  0% {
    transform: translateX(-50%);
  }
  50% {
    transform: translateY(4px) translateX(-50%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const TileContainer = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: relative;
  width: 200px;
  height: 200px;
`;

const FireIcon = styled.div`
  width: 130px;
  height: 190px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 32%;
  background: url(${stadiumFire}) no-repeat center / contain;
  animation: ${fireIconAnimation} 3s ease-in-out infinite;
`;

const fadeInKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const DelayedText = styled.div`
  opacity: 0;
  animation: ${fadeInKeyframes} 0.4s ease-out forwards;
`;

export const NewChapterOverlay = () => {
  const { sport } = useSportContext();

  return (
    <Overlay>
      <OverlayContent>
        <TileContainer style={{ viewTransitionName: VIEW_TRANSITION_NAME }}>
          <Tile color={DiamondBaseColor.orange} size={3} borderAnimated />
          <FireIcon
            style={{
              backgroundImage: `url(${sport === Sport.NBA ? nbaStadiumFire : stadiumFire})`,
            }}
          />
        </TileContainer>
        <DelayedText>
          <BrandL style={{ animationDelay: '400ms' }}>
            <FormattedMessage defaultMessage="New chapter" />
          </BrandL>
        </DelayedText>
        <DelayedText style={{ animationDelay: '800ms' }}>
          <BrandM color="var(--c-white)">
            <FormattedMessage defaultMessage="Unlocked" />
          </BrandM>
        </DelayedText>
      </OverlayContent>
    </Overlay>
  );
};
